import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CadouHero } from '../components/cadou/CadouHero';
import { CadouForWho } from '../components/cadou/CadouForWho';
import { CadouProcess } from '../components/cadou/CadouProcess';
import { CadouAbout } from '../components/cadou/CadouAbout';
import { CadouTestimonials } from '../components/cadou/CadouTestimonials';
import { CadouFinalCTA } from '../components/cadou/CadouFinalCTA';
export function CadouPage() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2284">
      <Header data-id="element-2285" />
      <main data-id="element-2286">
        <CadouHero data-id="element-2287" />
        <CadouForWho data-id="element-2288" />
        <CadouProcess data-id="element-2289" />
        <CadouAbout data-id="element-2290" />
        <CadouTestimonials data-id="element-2291" />
        <CadouFinalCTA data-id="element-2292" />
      </main>
      <Footer data-id="element-2293" />
    </div>;
}